import mod from "-!./AdminUI.js?vue&type=script&lang=js&external"; export default mod; export * from "-!./AdminUI.js?vue&type=script&lang=js&external"